module.exports = __webpack_public_path__ + "resources/img/27001.224034911d5dfee5551e5ebec28c7366.png";